import React from "react";

import styles from './styles/XBigButton.module.scss';

export interface IBigButtonProps {
    className?: string | null;
    children? : React.ReactNode;
    height? : string | null;
    width? : string | null;
    flexGrow? : number | null;
    text?: string | null;
    isActive?: boolean | null;
    //name:string;
    //optionalParam?:number;
}
export interface IBigButtonState {
    className?: string | null;
}

export class XBigButton extends React.Component<IBigButtonProps, IBigButtonState> {
    constructor(props: IBigButtonProps) {
        super(props);
        this.state = {
            className: this.props.className?? ''
        }
        this.setClass = this.setClass.bind(this);
    }
    setClass(value: string) {
        this.setState({className: value})
    }
    render() : React.ReactNode
    {
        const _class = styles.XButton + (this.props.className? ' ' + this.props.className : '');
        const text = this.props.text? this.props.text : '';

        return (
            <button className={_class?? ''}>{text}</button>
        );
    }
}